'use client';

import { useEffect, useState } from "react";
import { Box, Skeleton } from "@chakra-ui/react";
import dynamic from "next/dynamic";

// Components
import JoinUsSection from "components/home/JoinUsSection";
import BenefitClubBanner from "components/home/BenefitClubBanner";
import MustUpdateData from "components/common/MustUpdateDataModal";
import { LoadingSpinner } from "components/common/Loading";

const AppPromoBanner = dynamic(() => import("components/home/AppPromoBanner"), {
  ssr: false,
  loading: () => <LoadingSpinner />,
});

const NewsHome = dynamic(() => import("components/home/NewsSection").then(mod => mod.default), {
  ssr: false,
  loading: () => <LoadingSpinner />,
});

const PollsSection = dynamic(() => import("components/home/PollsSection").then(mod => mod.default), {
  ssr: false,
  loading: () => <LoadingSpinner />,
});

export default function Home() {
  const [showCustomDialog, setShowCustomDialog] = useState(false);

  useEffect(() => {
    const shouldShow = localStorage.getItem("showCustomDialog");

    if (shouldShow && shouldShow === "true") {
      setShowCustomDialog(true);
      localStorage.removeItem("showCustomDialog");
    }
  }, []);

  return (
    <Box 
      bg="white-bg" 
      w="100%" 
      overflowX="hidden"
      display="flex"
      flexDirection="column"
      alignItems="center"
    >
      <Box
        w="100%"
        maxW="85rem"
        px={[4, 6, 8]}
        mx="auto"
      >
        <JoinUsSection />
        <NewsHome />
        <BenefitClubBanner />
      </Box>
      
      <AppPromoBanner />
      
      <Box
        w="100%"
        maxW="85rem"
        px={[4, 6, 8]}
        mx="auto"
      >
        <PollsSection />
      </Box>
      
      
      {showCustomDialog && (
        <MustUpdateData />
      )}
    </Box>
  );
}